import { Card } from "@mui/material";
import CommonLayout from "components/CommonLayout";
import DiscountDetail from "components/DiscountDetails";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import OrderDetail from "components/OrderDetails";
import ProductDetail from "components/ProductDetails";
import React from "react";
import { useNavigate } from "react-router-dom";

const DiscountDetails = () => {
  const navigate = useNavigate();
  return (
    <CommonLayout>
      <Card sx={{ marginTop: 10, marginBottom: 10 }}>
        <MDBox
          // variant="gradient"
          bgColor="theme-1"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          sx={{ display: "flex", justifyContent: "space-between" }}
          // textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Discount Details
          </MDTypography>

          <MDTypography
            variant="h6"
            color="white"
            mt={1}
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/manage-discount")}
          >
            Back
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <DiscountDetail/>
        </MDBox>
      </Card>
    </CommonLayout>
  );
};

export default DiscountDetails;
